import { AuthenticatedPanel } from '../../auth/components/AuthenticatedPanel';
import { TopNavBar } from './TopNavBar';
import styles from './AppLayout.module.css';

export const AppLayout = ({
  user,
  token,
  entrySettings,
  pricingSettings,
  organization,
  activeBranch,
  accessibleBranchCount,
  onBranchSwitch,
  onLogout,
  onRefreshSession,
  t,
  locale,
  onLocaleChange,
}) => (
  <div className={styles.shell}>
    <AuthenticatedPanel
      user={user}
      token={token}
      entrySettings={entrySettings}
      pricingSettings={pricingSettings}
      activeBranch={activeBranch}
      onRefreshSession={onRefreshSession}
      t={t}
      locale={locale}
      renderHeader={({ activeModule, onMenuToggle, isMobileMenuOpen }) => (
        <TopNavBar
          username={user.username}
          role={user.role}
          token={token}
          activeBranch={activeBranch}
          accessibleBranchCount={accessibleBranchCount}
          onBranchSwitch={onBranchSwitch}
          onLogout={onLogout}
          t={t}
          locale={locale}
          onLocaleChange={onLocaleChange}
          title={activeModule ? t(activeModule.labelKey) : t('navDashboard')}
          onMenuToggle={onMenuToggle}
          isMobileMenuOpen={isMobileMenuOpen}
          organization={organization}
        />
      )}
    />
  </div>
);
